var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 5.25C1.75 4.32174 2.11875 3.4315 2.77513 2.77513C3.4315 2.11875 4.32174 1.75 5.25 1.75H6.85067C7.854 1.75 8.729 2.43367 8.97283 3.40667L10.262 8.56683C10.3665 8.9845 10.3454 9.4237 10.2013 9.82943C10.0573 10.2352 9.79676 10.5894 9.45233 10.8477L7.94383 11.9793C7.78633 12.0972 7.7525 12.2698 7.79683 12.39C8.45528 14.1807 9.49503 15.8068 10.8441 17.1559C12.1932 18.505 13.8193 19.5447 15.61 20.2032C15.7302 20.2475 15.9017 20.2137 16.0207 20.0562L17.1523 18.5477C17.4106 18.2032 17.7648 17.9427 18.1706 17.7987C18.5763 17.6546 19.0155 17.6335 19.4332 17.738L24.5933 19.0272C25.5663 19.271 26.25 20.146 26.25 21.1505V22.75C26.25 23.6783 25.8813 24.5685 25.2249 25.2249C24.5685 25.8813 23.6783 26.25 22.75 26.25H20.125C9.97733 26.25 1.75 18.0227 1.75 7.875V5.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallUs);
export default __webpack_public_path__ + "static/media/callUs.6a80bae7905bbec53983ab3e4f5fa969.svg";
export { ForwardRef as ReactComponent };